module.exports = ".container {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background: #eee; }\n  .container .inner {\n    text-align: left;\n    padding: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/countries-view/countries-view.component.scss
// module id = ./src/app/components/views/countries-view/countries-view.component.scss
// module chunks = main